import controller from './map.controller';

const template = require('./map.html');

export default {
    bindings: {
        mapOptions: '<',
        centerCoordinates: '<',
        marker: '=',
        onCenterChanged: '&',
        onBoundsChanged: '&',
        onMarkerCoordinatesChanged: '&?'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/map/map.component.js